import React, { Component } from 'react';
import { connect } from 'formik';
import cn from 'classnames';
import { injectIntl } from 'react-intl';

import './checkout-summary-bar.scss';

import CheckoutSummaryPanel from './checkout-summary-panel.js';

class CheckoutSummaryBar extends Component {
	state = {
		openSummary: false,
	};

	toggleSummary = () => {
		this.setState(prevState => ({
			openSummary: !prevState.openSummary,
		}));
	};

	render() {
		const { formik: { values }, intl } = this.props;
		const { openSummary } = this.state;

		const {
			 selectedMethod, prices, extras,
		} = values;

		function getEmailAndSMSPrice() {
			return selectedMethod === 'email+sms' ? 2 : 0;
		}

		function getPrice(amount, quantity) {
			return amount * quantity;
		}

		function getTotalPrice() {
			const ticketsSum = prices.reduce(
				(accumulator, currentValue) => accumulator + getPrice(currentValue.value, currentValue.quantity),
				0,
			);
			const extrasSum = extras.reduce(
				(accumulator, currentValue) => accumulator + getPrice(currentValue.price, currentValue.quantity),
				0,
			);

			return ticketsSum + extrasSum + getEmailAndSMSPrice();
		}

		return (
			<div className="summary-bar">
				<div className="bottom-bar" onClick={this.toggleSummary}>
					<div className="container container-fluid">
						<div className="content">
							<div className="label">{intl.formatMessage({ id: 'checkout.summary-bar.show.details' })}</div>
							<div className="price">{`${getTotalPrice()}€`}</div>
						</div>
					</div>
				</div>
				<div className={cn('summary ', { open: openSummary })}>
					<div className="summary-wrapper">
						<div className="close-button" onClick={this.toggleSummary} />
						<div className="summary-content">
							<div className="summary-content-wrapper">
								<div className="container container-fluid">
									<CheckoutSummaryPanel />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}


export default injectIntl(connect(CheckoutSummaryBar));
